var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.6666C18.2091 18.6666 20 16.8758 20 14.6666C20 12.4575 18.2091 10.6666 16 10.6666C13.7909 10.6666 12 12.4575 12 14.6666C12 16.8758 13.7909 18.6666 16 18.6666Z",
    stroke: "#84DADE",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5433 22.2093L17.886 27.8666C17.386 28.3662 16.7081 28.6467 16.0013 28.6467C15.2945 28.6467 14.6167 28.3662 14.1167 27.8666L8.45799 22.2093C6.96628 20.7175 5.95044 18.8169 5.53891 16.7478C5.12737 14.6787 5.33864 12.534 6.14599 10.585C6.95334 8.6359 8.32052 6.97003 10.0746 5.79799C11.8287 4.62594 13.891 4.00037 16.0007 4.00037C18.1103 4.00037 20.1726 4.62594 21.9267 5.79799C23.6808 6.97003 25.048 8.6359 25.8553 10.585C26.6627 12.534 26.8739 14.6787 26.4624 16.7478C26.0509 18.8169 25.035 20.7175 23.5433 22.2093V22.2093Z",
    stroke: "#84DADE",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbic);
export default __webpack_public_path__ + "static/media/ubic.0647a3b7578c9bd0cfebdcbb16487d1a.svg";
export { ForwardRef as ReactComponent };